import { createSlice } from '@reduxjs/toolkit';
import { post } from '../../helpers/fetchServicesMethods';
import utilsService, { TOAST_TYPE } from '../../helpers/utils'
import { url } from '../url';
import { getUserServerInfo } from './userServerDataSlice';
import PubSub from 'pubsub-js';
import { cacheUserPayload, setAuthSession } from '../../services/storage/GQStorage';

function showLoader() {
    PubSub.publish('msg', true);
}

function hideLoader() {
    PubSub.publish('msg', false);
}

const initialState = { isLoggedIn: false }

export const submitLogin = (data, history, t, toastRef, onLoginSuccess, fromUrl) => async (dispatch) => {
    const postdata = new FormData();

    if(data.GQUSERID !== undefined && data.GQUSERID !==null){
        postdata.append("GQUSERID", data.GQUSERID);
    }
    if(data.GQPASSWORD !== undefined && data.GQPASSWORD !==null){
        postdata.append("GQPASSWORD", data.GQPASSWORD);
    }
    if(data.preferred_username !== undefined && data.preferred_username !==null){
        postdata.append("ACUSERNAME", data.preferred_username);
    }
    if(data.coid !== undefined && data.coid !==null){
        postdata.append("COID", data.coid);
    }
    if(data.uoid !== undefined && data.uoid !==null){
        postdata.append("UOID", data.uoid);
    }


    showLoader();

    return post(url.ftlogin, postdata, history)
        .then(async (response) => {
            hideLoader();
            if (response && response.response_status === 0) {
                await dispatch(getUserServerInfo());
                //await dispatch(getPageCount());
                utilsService.showToast(TOAST_TYPE.SUCCESS, t('loginSuccess'), toastRef)
                const userName = data.GQUSERID || data.preferred_username;
                cacheUserPayload(userName, response);
                setAuthSession({
                    isLoggedIn: true,
                    userName,
                    authMethod: data.preferred_username ? 'sso' : 'password',
                    providerId: data.preferred_username ? 'appcentral' : 'local'
                });
                dispatch(setUser({ GQUSERID: userName, isLoggedIn: true }));
                // Default: land on /home. When a caller (e.g. /oauth-authorize)
                // supplies onLoginSuccess, hand control back to it instead so it
                // can continue its own flow without a detour through /home.
                if (typeof onLoginSuccess === 'function') {
                    onLoginSuccess();
                } else if (response.response_content && response.response_content.return_url) {
                    // Redirect to the return URL
                    // history.push(response.return_url);
                    window.location = response.response_content.return_url;
                } else {
                    history.push(fromUrl || '/home');
                }
            } else {
                let errorMsg = 'Unable to Login';
                dispatch(setUser({ isLoggedIn: false }));
                setAuthSession({ isLoggedIn: false });
                if (response && typeof response.response_content === 'object' && response.response_content !== null) {
                    errorMsg = response;
                }
                return errorMsg;
                // toast.error(errorMsg);

            }
        })
        .catch((error) => {
            hideLoader();
            utilsService.showToast(TOAST_TYPE.ERROR, t('loginFailed'), toastRef)
            console.log("error::", error);
        });
};

export const submitMfaCode = (mfaCode, userName, mfaToken, trustDevice, history, t, toastRef) => async (dispatch) => {
    const data = new FormData();
    data.append("mfa_code", mfaCode);
    if (userName) {
        data.append("GQUSERID", userName);
    }
    if (mfaToken) {
        data.append("mfa_token", mfaToken);
    }
    data.append("trust_device", trustDevice ? "1" : "");

    showLoader();

    return post(url.verifyMfa, data, history)
        .then(async (response) => {
            hideLoader();
            if (response && response.response_status === 0) {
                await dispatch(getUserServerInfo());
                utilsService.showToast(TOAST_TYPE.SUCCESS, t('loginSuccess'), toastRef);
                cacheUserPayload(userName, response);
                setAuthSession({
                    isLoggedIn: true,
                    userName,
                    authMethod: 'password',
                    providerId: 'local'
                });
                dispatch(setUser({ GQUSERID: userName, isLoggedIn: true }));
                history.push('/home');
            } else {
                return response;
            }
        })
        .catch((error) => {
            hideLoader();
            utilsService.showToast(TOAST_TYPE.ERROR, t('loginFailed'), toastRef);
            console.log("error::", error);
        });
};

export const resendMfaCode = (userName, mfaToken, history, t, toastRef) => async () => {
    const data = new FormData();
    if (userName) {
        data.append("GQUSERID", userName);
    }
    if (mfaToken) {
        data.append("mfa_token", mfaToken);
    }

    showLoader();

    return post(url.resendMfa, data, history)
        .then((response) => {
            hideLoader();
            if (response && response.response_status === 0) {
                utilsService.showToast(TOAST_TYPE.SUCCESS, t('mfaCodeResent'), toastRef);
            }
            return response;
        })
        .catch((error) => {
            hideLoader();
            utilsService.showToast(TOAST_TYPE.ERROR, t('loginFailed'), toastRef);
            console.log("error::", error);
        });
};

export const LoginSSO = (data, history, t, toastRef) => async (dispatch) => {
        const postdata = new FormData();
        postdata.append("GQUSERID", data.GQUSERID);
        postdata.append("apitoken", data.apiToken);
        showLoader()

        return post(url.loginSSO, postdata, history)
         .then(async (response) => {
            hideLoader();
            if (response && response.response_status == 0) {
                await dispatch(getUserServerInfo());
                //await dispatch(getPageCount());
                utilsService.showToast(TOAST_TYPE.SUCCESS, t('loginSuccess'), toastRef)
                cacheUserPayload(data.GQUSERID, response);
                setAuthSession({
                    isLoggedIn: true,
                    userName: data.GQUSERID,
                    authMethod: 'sso',
                    providerId: 'appcentral'
                });
                dispatch(setUser({ GQUSERID: data.GQUSERID, isLoggedIn: true }));
                history.push('/home');

            }
        }).catch((error) => {
            hideLoader();
            utilsService.showToast(TOAST_TYPE.ERROR, t('loginFailed'), toastRef)
            console.log("error::", error);
        });

}

const loginSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        setUser: (state, action) => action.payload
    },
})

export const { setUser } = loginSlice.actions;
export default loginSlice.reducer;
